// extracted by mini-css-extract-plugin
export var inputContainer = "_ox-0";